import React from 'react'
import UserProfileContext from '../../context/UserProfileContext'
import { UserProfile } from '../UserProfile/UserProfile'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'



export const ProfileProposalForm = () => {

    const save = () => EventEmitterService.dispatch(EventKey.USER_PROFILE_SAVE)

    return ( <UserProfileContext>
            <UserProfile /> 
        </UserProfileContext>
    )
}